export const aciPeople = {
    iconName: 'people',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 11 25' },
        path: {
            attr: {
                'clip-rule': 'evenodd',
                d: 'M5.326 7.922a3.461 3.461 0 100-6.922 3.461 3.461 0 000 6.922zM9.653 16.575v-2.596a4.326 4.326 0 10-8.653 0v2.596h1.73l.866 6.922h3.46l.866-6.922h1.73z',
                stroke: 'currentColor',
                'stroke-width': '1.184',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
